<template>
  <div class="main" :style="{ width: width }">
    <div class="data-table">
      <div class="top-container" v-if="showHeaderRow">
        <div
          v-for="(header, i) in headers"
          :key="i"
          :style="{ width: header.width }"
          class="test"
        >
          <div
            :class="
              hideVerticalLine || i === headers.length - 1
                ? 'no-border-right'
                : 'border-right'
            "
            class="header-container left-align"
            :style="[
              { 'font-size': header.size ? header.size : '' },
              headerCustomStyle,
            ]"
          >
            {{ header.name }}
            <div
              :style="{ display: header.sortable ? 'flex' : 'none' }"
              :class="
                header.key != sortByKey
                  ? 'sort-buttons'
                  : 'sort-buttons-visible'
              "
            >
              <i
                @click="
                  sortByKey = header.key;
                  order = 'ASC';
                  clickSort(header.key, 'ASC');
                "
                :class="
                  header.key === sortByKey && order === 'ASC'
                    ? `selected-sort`
                    : `unselected-sort`
                "
                class="up"
                :id="`sort-${header.key}-asc`"
              >
                <BaseIcon name="arrowUpSort" width="1rem" height="1rem" />
              </i>
              <i
                @click="
                  sortByKey = header.key;
                  order = 'DES';
                  clickSort(header.key, 'DES');
                "
                :class="
                  header.key === sortByKey && order === 'DES'
                    ? `selected-sort`
                    : `unselected-sort`
                "
                class="down"
                :id="`sort-${header.key}-des`"
              >
                <BaseIcon name="arrowDownSort" width="1rem" height="1rem" />
              </i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="data-container"
        :class="
          tableRowProperties.showFirstRowTopBorder
            ? 'border-top-left-right-radius'
            : ''
        "
      >
        <Loading v-if="loading" />
        <div
          v-else
          class="data-container"
          :style="{
            height: height,
          }"
        >
          <div v-if="items.length === 0 && !loading" class="parent-no-data">
            <NoData :message="$t('noData')" v-if="showNoData"></NoData>
          </div>

          <div
            v-if="items.length > 0 && !loading && showHeaderRow"
            class="dummy-top-parent"
          >
            <div
              v-for="(header, i) in headers"
              :key="i"
              :style="{
                width: header.width,
                height: showHeaderRow ? '0.825rem' : '0.425rem !important',
              }"
              class="dummy-top"
              :class="
                !tableRowProperties.showAleternateColor
                  ? hideVerticalLine || j === headers.length - 1
                    ? 'no-border-right table-td'
                    : 'border-right table-td'
                  : hideVerticalLine || j === headers.length - 1
                    ? 'no-border-right table-td-naltcol'
                    : 'border-right table-td-naltcol'
              "
            ></div>
          </div>
          <div
            v-for="(item, i) in items"
            :key="i"
            class="table-row"
            :style="
              formStyle(rowCustomStyle) +
              ('border-top' +
                ':' +
                (i === 0
                  ? tableRowProperties.showFirstRowTopBorder
                    ? '0.3em solid rgb(30,32,33)'
                    : 'none'
                  : 'none'))
            "
          >
            <div
              v-for="(header, j) in headers"
              :key="i + ' ' + j"
              :style="
                tableRowProperties.showAleternateColor
                  ? {
                      width: header.width,
                      background:
                        i % 2 === 0 ? highlightColor : 'rgb(30,32,33)',
                    }
                  : formStyle({
                      width: header.width,
                      rowCustomStyle,
                    })
              "
              :class="
                tableRowProperties.showAleternateColor
                  ? hideVerticalLine || j === headers.length - 1
                    ? 'no-border-right table-td'
                    : 'border-right table-td'
                  : hideVerticalLine || j === headers.length - 1
                    ? 'no-border-right table-td-naltcol'
                    : 'border-right table-td-naltcol'
              "
            >
              <div
                v-if="header.icon"
                :id="`catch-event-${i}-${j}`"
                class="icon-cell"
              >
                <div class="conditional-div" v-if="header.secondaryIcon">
                  <span :class="header.secIconColor ? 'white' : 'yellow'">
                    <BaseIcon
                      v-if="checkCondition(item)"
                      :name="header.cellIcon"
                      height="1.2rem"
                      width="1.2rem"
                      v-tooltip:top="{
                        content: iconTooltipDataConditional,
                        disabled:
                          iconTooltipDataConditional == null ||
                          iconTooltipDataConditional.length == 0,
                      }"
                    ></BaseIcon>
                  </span>
                </div>
                <span @click="catchEvent(header.event, item)">
                  <BaseIcon
                    :name="header.icon"
                    class="ptr-cursor"
                    height="1.2rem"
                    width="1.2rem"
                    v-tooltip:top="{
                      content: iconTooltipData,
                      disabled:
                        iconTooltipData == null || iconTooltipData.length == 0,
                    }"
                  ></BaseIcon>
                </span>
                <span class="cls-col-txt">
                  {{ item[header.key] }}
                </span>
              </div>
              <div
                v-else-if="header.tdIconEnable && item.typeIcon.name"
                @click="catchEvent(header.event, item)"
              >
                <BaseIcon
                  :name="item.typeIcon.name"
                  width="1em"
                  height="1.5em"
                  :iconColor="item.typeIcon.style.color"
                ></BaseIcon>
              </div>
              <div
                v-else-if="header.type === 'cellWithAction'"
                class="cell-action-container"
              >
                <div class="cell-with-action">
                  <span class="cursor-pointer" @click="redirectTo(item, j)">
                    {{ item[header.key] }}
                  </span>
                  <span @click="catchEvent(header.event, item)">
                    <BaseIcon
                      :name="header.cellIcon"
                      class="ptr-cursor"
                      height="1.2rem"
                      width="1.2rem"
                      v-tooltip:top="{
                        content: iconTooltipData,
                        disabled:
                          iconTooltipData == null ||
                          iconTooltipData.length == 0,
                      }"
                    ></BaseIcon>
                  </span>
                </div>
              </div>
              <div
                v-else-if="header.type === 'cellWithActionConditional'"
                class="cell-action-container"
              >
                <div class="cell-with-action">
                  <span
                    class="cls-col-txt cursor-pointer"
                    @click="redirectTo(item, j)"
                  >
                    {{ item[header.key] }}
                  </span>
                  <span @click="catchEvent(header.event, item)">
                    <BaseIcon
                      v-if="checkCondition(item)"
                      :name="header.cellIcon"
                      class="ptr-cursor"
                      height="1.2rem"
                      width="1.2rem"
                      v-tooltip:top="{
                        content: iconTooltipData,
                        disabled:
                          iconTooltipData == null ||
                          iconTooltipData.length == 0,
                      }"
                    ></BaseIcon>
                  </span>
                </div>
              </div>

              <div
                v-else-if="header.type === 'renderDynamicComponent'"
                class="dynamic-comp-container"
              >
                <component
                  :is="header.formatComponent"
                  :row="item"
                  :header="header"
                ></component>
              </div>

              <div
                v-else-if="
                  redirectable &&
                  header.key != 'modified' &&
                  header.key != 'startTime'
                "
                @click="redirectTo(item, j)"
                :class="header.isEllipsisReq ? 'ellipsis-redirect' : ''"
                v-tooltip:left="{
                  content: item[header.key],
                  disabled: !header.isEllipsisReq || !item[header.key],
                }"
                :id="`redirect-${i}-${j}`"
                :style="{
                  cursor:
                    header.routable === false
                      ? cursorType.auto
                      : cursorType.pointer,
                }"
              >
                <span
                  v-html="getValue(header, item)"
                  :class="`td-span ${tdSpanClass}`"
                ></span>
              </div>

              <div v-else-if="header.key === 'startTime'">
                {{
                  $filters.dateformat(
                    parseInt(item[header.key]),
                    timezoneoffset,
                    dateTime,
                  )
                }}
              </div>
              <div v-else-if="header.key === 'modified'">
                {{ item['modified'] }} {{ ', ' }}
                {{
                  $filters.dateformat(
                    parseInt(item['lastUpdate']),
                    timezoneoffset,
                    dateTime,
                  )
                }}
              </div>
              <div v-else>
                <span v-html="item[header.key]" class="td-span"> </span>
              </div>
              <div v-if="header.type === 'actions'" class="actions">
                <div v-for="(action, k) in actions" :key="`action-${k}`">
                  <button
                    class="action-btn"
                    @click="actionClick(item, action.type)"
                  >
                    <BaseIcon
                      :name="action.icon"
                      width="1.2em"
                      height="1.2em"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Dummy row is used to extend border to cover table height -->
          <div
            v-if="items.length > 0 && !loading && showHeaderRow"
            class="dummy-parent"
          >
            <div
              v-for="(header, i) in headers"
              :key="i"
              :style="{ width: header.width }"
              class="dummy"
              :class="
                hideVerticalLine || i === headers.length - 1
                  ? 'no-border-right'
                  : 'border-right'
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { dateTime } from '@/utils/time/dateconstants';
import NoData from '@/rex-components/rex-no-data.vue';
import Loading from '@/rex-components/rex-loading.vue';
import { DataTypes } from '@/utils/enums/dataTypes';
import { formatDate } from '@/utils/time/formatDate';
export default {
  components: { NoData, Loading },
  props: {
    /**
     *
     *The columns for the table with information about the widths of the columns, sortable, default sort and order
     * @example
      headers: [
        {
          key: name,
          name: this.$t('name'),
          width: '36%',
          sortable: false,
          size: '1.0rem'
        },
        {
          key: alerts,
          name: this.$t('alerts'),
          width: '14%',
          sortable: true,
          dataType: 'float',
          defaultOrder: DES,
          defaultSortBy: true
        },
        ]
     *
     */
    headers: { type: Array, required: true },

    showHeaderRow: { type: Boolean, default: true },
    tableRowProperties: {
      type: Object,
      // default: () => {
      //   return {
      //     aleternateColor: true,
      //     showFirstRowTopBorder: true,
      //     background: 'rgb(41,44,50)',
      //   };
      // },
    },

    /**
     *
     *Data of the table to be displayed
     *
     */
    items: { type: Array, required: true },
    /**
     *
     *If the table has search function
     *
     */
    redirectable: { type: Boolean, default: true },
    /**
     *
     *If table has actions on row elements
     *
     */
    actions: { type: Array },
    /**
     *
     *The accent color of the table on entries
     *
     */
    highlight: { type: String, default: 'primary' },
    /**
     *
     *Height of the table
     *
     */
    height: { type: String, required: true },
    /**
     *
     *Width of the table as percentage of the page
     *
     */
    width: { type: String, required: true },
    /**
     *
     *For component level loading
     *
     */
    loading: { type: Boolean },

    /**
     *
     * Vertical line should be hidden or not
     *
     */
    hideVerticalLine: { type: Boolean, default: false },

    /**
     *
     * Pass styles object to modify the headers accordingly
     *
     */
    headerCustomStyle: { type: Object, default: () => {} },

    /**
     *
     * Pass the tooltip content here,
     * if nothing is passed it will disable the tooltip
     *
     */
    iconTooltipData: { type: String, default: '' },
    /** * * Pass the tooltip for coditional content here, * if nothing is passed it will disable
the tooltip * */
    iconTooltipDataConditional: {
      type: String,
      default: '',
    },

    /**
     *
     * Pass the name of the class for td elements styling
     *
     */
    tdSpanClass: { type: String, default: '' },
    /** * * Pass the name of the condition to render icon for cellWithActionConditional header type * */
    condition: {
      type: String,
      default: '',
    },
    rowCustomStyle: {
      type: Object,
      default: () => ({}),
    },
    showNoData: { type: Boolean, default: true },
  },
  data() {
    return {
      dateTime,
      curr: '',
      sortByKey: '',
      order: '',
      dataType: '',
      showSearch: false,
      cursorType: {
        pointer: 'pointer',
        auto: 'auto',
      },
    };
  },
  computed: {
    ...mapState('globalState/settings', ['timezoneoffset']),
    filteredItems() {
      return this.filter();
    },
    isAnyFilterSelected() {
      return this.isFilterSelected();
    },
    highlightColor() {
      return this.highlight === 'primary' ? 'rgb(41,44,50)' : 'rgb(41,44,50)';
    },
  },
  methods: {
    redirectTo(option, columnID) {
      this.$emit('redirectInput', option, this.headers[columnID].key);
    },

    clickSort(col, order) {
      let item = { header: col, order: order };
      this.$emit('updateSort', item);
    },
    actionClick(item, type) {
      let actionItem = { item: item, type: type };
      this.$emit('tableAction', actionItem);
    },
    catchEvent(eventName, item) {
      this.$emit(eventName, item);
    },
    getValue(header, item) {
      if (header.dataType === DataTypes.TIME) {
        return formatDate(item[header.key], this.timezoneoffset);
      } else return item[header.key];
    },
    checkCondition(item) {
      const prop = this.condition;
      if (item[prop]) return true;
      else return false;
    },
    intiDefaultSort() {
      for (let i in this.headers) {
        let header = this.headers[i];
        if (header.defaultSortBy) {
          this.sortByKey = header.key;
          this.order = header.defaultOrder;
        }
      }
    },
    formStyle(_object, isJSON) {
      var _style = '';
      for (const key in _object) {
        _style += key + ':' + _object[key] + (isJSON ? ',' : ';');
      }
      return _style;
    },
  },
  created() {
    this.intiDefaultSort();
  },
};
</script>
<style lang="scss" scoped>
.dummy {
  height: 100%;
  display: inline-flex;
  &:last-child {
    border-right: none;
  }
}
.dummy-top {
  height: 0.825rem;
  &:last-child {
    border-right: none;
  }
}
.dummy-top-parent {
  display: flex;
}
.dummy-parent {
  flex-grow: 1;
}
.table-row {
  display: flex;
  background: $bg-secondary;
}
.table-td {
  display: inline;
  align-items: center;
  text-align: left;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-align: left;
  min-height: 2.75rem;
  height: auto;
  padding: {
    top: 0.3rem;
    bottom: 0.3rem;
    left: 1.8725rem;
    right: 2.325rem;
  }
}
.table-td-naltcol {
  display: inline;
  align-items: center;
  text-align: left;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-align: left;
  min-height: 2.75rem;
  height: auto;
}
.padding-div {
  padding: {
    top: 0.3rem;
    bottom: 0.3rem;
    left: 1.8725rem;
    right: 2.325rem;
  }
  .semibold {
    font-family: $bold;
  }
  .good {
    color: $good;
  }
  .poor {
    color: $poor;
  }
  .fair {
    color: $fair;
  }
  .primary {
    background-color: $highlight-primary;
  }
  .secondary {
    background-color: $highlight-secondary;
  }
  .colorHeading {
    color: $font-primary;
  }
}
.table-td:first-child {
  border-left: 0.825rem solid $bg-secondary;
  padding-left: 1.044rem;
}

.table-td:last-child {
  border-right: 0.825rem solid $bg-secondary;
}

.main {
  @include dropshadow-effect();
  border-radius: 1.0625rem;
}
.no-border-right {
  border-right: none;
}
.border-right {
  border-right: $border-primary 0.0125rem solid;
}
.data-table {
  border-bottom-left-radius: 1.0625rem;
  border-bottom-right-radius: 1.0625rem;
  //border: 0.0063rem $border-color-primary solid;
  border-radius: 1.0625rem;
}
.container-section {
  display: flex;
  flex-direction: row;
  .left-align {
    justify-content: flex-start;
  }
  .center-align {
    justify-content: center;
  }
}
.header-container {
  padding-left: 1.625rem;
}
.top-container:first-child > .header-container:first-child {
  padding-left: 1.625rem;
}
.top-container:first-child > .header-container {
  padding-left: 1.625rem;
}
.test {
  //border-right: $border-primary 0.0125rem solid;
}
.test:first-child > .header-container {
  border-top-left-radius: 0.7875rem;
  //padding-left: 1.8725rem;
}
.test > .header-container {
  padding-left: 1.8725rem;
}
.test:last-child > .header-container {
  border-top-right-radius: 0.7875rem;
  border-right: 0px;
}
.left-align {
  justify-content: flex-start;
  padding-left: 0.625rem;
  text-align: left;
}
.center-align {
  justify-content: center;
}
.top-container {
  position: relative;
  display: flex;
}
.header-container {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 0.0125rem solid $border-color-primary;
  color: $font-primary;
  font-family: $semi-bold;
  font-size: 1.25rem;
  height: 3.5rem;
  background-color: $bg-tertiary;
}
.sort-buttons-visible {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  cursor: pointer;
}
.sort-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  cursor: pointer;
  visibility: hidden;
}
.selected-sort {
  z-index: 1;
  fill: $color-brand-accent;
}
.unselected-sort {
  fill: $color-brand-accent-inactive;
  z-index: 2;
}
.up {
  margin-left: 0.5rem;
}
.down {
  margin-right: 0.5rem;
}
.container-section {
  height: 100%;
}
.content-full {
  border-right: $border-primary 0.2px solid;
  height: 100%;
}
.container-section:first-child > .content-full {
  padding-left: 1rem;
}
.container-section:first-child > .content-full > {
  padding-left: 1rem;
}
.container-section:last-child > .content-full {
  padding-right: 1rem;
}
.content-container {
  //border-right: $border-primary 0.2px solid;
}
.container-section:first-child
  > .content-full
  > .content-container
  > .content-row {
  padding-left: 1.625rem;
}
.container-section:last-child > .content-full > .content-container:last-child {
  border-right: none;
}

.border-top-left-right-radius {
  border-top-left-radius: 0.688rem;
  border-top-right-radius: 0.688rem;
}
.data-container {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background: $bg-secondary;
  border-bottom-left-radius: 0.688rem;
  border-bottom-right-radius: 0.688rem;
  width: 59rem;
  .content-container {
    //border-right: $border-primary 0.2px solid;
    .content-row {
      display: flex;
      align-items: center;
      overflow: hidden;
      margin: 0.475rem 0rem 0.475rem 0rem;
      text-align: left;
      &:first-child {
        margin-top: 1rem;
      }
      padding: {
        top: 0.3rem;
        bottom: 0.3rem;
        left: 2.325rem;
      }
      .semibold {
        font-family: $bold;
      }
      .good {
        color: $good;
      }
      .poor {
        color: $poor;
      }
      .fair {
        color: $fair;
      }
      .primary {
        background-color: $highlight-primary;
      }
      .secondary {
        background-color: $highlight-secondary;
      }
      .colorHeading {
        color: $font-primary;
      }
    }
  }
}
//removing the scroll width for the table overflow
//for chrome and safari
.data-container::-webkit-scrollbar {
  width: 0 !important;
}
//for edge and firefox
.data-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.search-btn {
  margin: 0px 0.625rem;
  @include svg-fill-pointer($font-primary);
}
.search-input {
  position: absolute;
  display: flex;
  height: 2.25rem;
  width: 17rem;
  border-radius: 0.1875rem;
  border: 0.0625rem $color-brand-accent solid;
  background-color: $bg-primary;
  z-index: 4;
  margin-left: 1.25rem;
  margin-top: 0.25rem;
  padding: 0.3rem 0rem;
  input {
    border: none;
    caret-color: $color-brand-accent;
    color: $font-primary;
  }
  textarea:focus,
  input:focus {
    outline: none;
  }
}
.redirect {
  cursor: pointer;
}
.pagination {
  height: 3.75rem;
  display: flex;
  justify-content: flex-end;
}
.action-btn {
  @include btn-reset;
  fill: $color-brand-accent;
}

.actions {
  display: flex;
  flex-direction: row;
}
.action-btn {
  margin: 0rem 0.625rem;
}
.header-container:hover > .sort-buttons {
  visibility: visible;
}
.content-row:first-child {
  padding-top: 0.625rem;
}
.row-icon {
  margin-right: 1rem;
  cursor: pointer;
}
.td-span {
  word-break: break-word;
}
.cls-col-txt {
  padding-left: 1.25rem;
}
.cursor-pointer:hover {
  cursor: pointer;
}

.parent-no-data {
  height: 100%;
}
.sm-font-size {
  font-size: 0.875rem;
}
.ellipsis-redirect {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 31rem;
  padding-right: 0.5rem;
}
.cell-with-action {
  display: flex;
  justify-content: space-between;
}
.cell-action-container {
  width: 100%;
}
.yellow {
  fill: $color-brand-accent;
}
.white {
  fill: $color-white;
}
.conditional-div {
  display: inline-block;
  width: 30%;
}
.icon-cell {
  width: 100%;
}
.dynamic-comp-container {
  width: 100%;
}
.ellipsis-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
